import { render, staticRenderFns } from "./moduloMenu.vue?vue&type=template&id=862291b6&scoped=true"
import script from "./moduloMenu.vue?vue&type=script&lang=js"
export * from "./moduloMenu.vue?vue&type=script&lang=js"
import style0 from "./moduloMenu.vue?vue&type=style&index=0&id=862291b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862291b6",
  null
  
)

export default component.exports